
(function($) {

    $(document).ready(function() {

        $('[data-toggle=click]').click(function () {
            var $target = $($(this).data('target'));
            if ($target.length) {
                if ($target.hasClass('menu-link') || $target.hasClass('submenu-link')) {
                    if ($target.is(':visible')) {
                        $target.parent().superfish('show');
                        $target.parent().find('>.submenu').addClass('remain-open')
                        $target.closest('.navbar').addClass('remain-open')
                    } else {
                        window.location = $(this).data('href') || $(this).attr('href');
                    }
                } else {
                    $target.click();
                }
            }
            return false;
        })

    });

})(jQuery);
